import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-gates-section',
  templateUrl: './gates-section.component.html',
  styleUrls: ['./gates-section.component.less'],
})
export class GatesSectionComponent {
  @Input() isEdit: boolean;
  @Input() gates: { id?: string; name: string }[] = [];
  @Output() gatesChange = new EventEmitter<{ id?: string; name: string }[]>();

  newGateName: string = '';

  isAddingNewGate = false;
  openContextMenu = false;
  gateIndex: number;

  toggleIsAddingNewGate(event) {
    event.stopPropagation();
    this.isAddingNewGate = !this.isAddingNewGate;
  }

  addGate(): void {
    if (this.newGateName.trim() !== '') {
      this.gates.push({ name: this.newGateName.trim() });
      this.gatesChange.emit([...this.gates]);
      this.newGateName = '';
    }
  }

  removeGate(index: number): void {
    this.gates.splice(index, 1);
    this.gatesChange.emit([...this.gates]);
    this.openContextMenu = false;
  }

  resetGates(): void {
    this.gates = [];
    this.gatesChange.emit([...this.gates]);
  }
  showContextMenu(index: number) {
    this.openContextMenu = !this.openContextMenu;
    this.gateIndex = index;
  }
}
